import { OrderModel } from '@/order/models/OrderModel'

export type OrderStatusTone = 'muted' | 'success' | 'danger' | 'warning' | 'info'

export type OrderStage = 'pending' | 'integrating' | 'pendingAssignment' | 'approved' | 'billed' | 'posted'
    | 'delivered' | 'finalized' | 'canceled' | 'error'

export interface OrderStatusStyle {
    icon: string
    tone: OrderStatusTone
    // Etapa na jornada Pendente > Aprovado > Faturado > Enviado > Entregue (-1: fora dela)
    step: number
    // Situação exata, para a ilustração da etapa (duas situações podem cair na mesma etapa)
    stage: OrderStage
}

export const ORDER_JOURNEY = ['Pendente', 'Aprovado', 'Faturado', 'Enviado', 'Entregue']

/**
 * Ícone, cor e etapa de cada status, com os mesmos ícones da listagem de
 * pedidos. Pendente fica em tom de aviso e importando em tom informativo, para
 * se destacarem no detalhe. Cancelado e erro ficam fora da jornada.
 */
export function getOrderStatusStyle(order: OrderModel): OrderStatusStyle {
    if (order.isCanceled()) {
        return {icon: 'window-close', tone: 'danger', step: -1, stage: 'canceled'}
    }

    if (order.isError()) {
        return {icon: 'exclamation-triangle', tone: 'danger', step: -1, stage: 'error'}
    }

    if (order.isPendingAssignment()) {
        return {icon: 'link', tone: 'warning', step: 0, stage: 'pendingAssignment'}
    }

    if (order.isIntegrating()) {
        return {icon: 'cloud-download-alt', tone: 'info', step: 0, stage: 'integrating'}
    }

    if (order.isApproved()) {
        return {icon: 'check-circle', tone: 'success', step: 1, stage: 'approved'}
    }

    if (order.isBilled()) {
        return {icon: 'money-bill-wave', tone: 'success', step: 2, stage: 'billed'}
    }

    if (order.isPosted()) {
        return {icon: 'truck-loading', tone: 'success', step: 3, stage: 'posted'}
    }

    if (order.isDelivered()) {
        return {icon: 'handshake', tone: 'success', step: 4, stage: 'delivered'}
    }

    if (order.isFinalized()) {
        return {icon: 'flag-checkered', tone: 'success', step: 4, stage: 'finalized'}
    }

    // Pendente pede atenção (em geral, o pagamento): não pode passar despercebido como um status neutro
    return {icon: 'hourglass-start', tone: 'warning', step: 0, stage: 'pending'}
}

// Linha extra sob a etapa atual no popover da barrinha, só quando explica algo
// que o nome da etapa e o status (já visível na linha) não dizem.
const STAGE_HINTS: Partial<Record<OrderStage, string>> = {
    pending: 'Aguardando pagamento ou aprovação no canal',
    integrating: 'O Muven está trazendo o pedido do canal',
    pendingAssignment: 'Há algo no pedido que está sem associação no Muven',
}

export function getOrderStageHint(stage: OrderStage): string {
    return STAGE_HINTS[stage] || ''
}
